import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=0203d54f&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0203d54f')) {
      api.createRecord('0203d54f', component.options)
    } else {
      api.reload('0203d54f', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=0203d54f&", function () {
      api.rerender('0203d54f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/Statistics.vue"
export default component.exports